export const PermissionType = Object.freeze({
	Read: 41,
	Full: 42,
});
